export const GET_SHIPPING_EVENT_FLASH_AR = "/shipping-events/flashArNew/:id"

export const GET_SHIPPING_EVENT_FLASH_AR_PDF = "/shipping-events/flashAr/v2/:id"

export const GET_SHIPPING_EVENT_MOBI_AR = "/shipping-events/mobiAr/:id"

export const GET_SHIPPING_EVENT_INTERLOG_AR = "/shipping-events/interlogAr/:id"

export const POST_SHIPPING_EVENT = "/shipping-events"

export const DELETE_SHIPPING_EVENT_BY_ID = "/shipping-events/:id"

export const RESTORE_SHIPPING_EVENT_BY_ID = "/shipping-events/:id/restore"

export const GET_STATUS_SAFRA = "/status-safra"

export const GET_ALL_STATUS_SAFRA = "/status-safra/all"

export const DELETE_STATUS_SAFRA_BY_ID = "/status-safra/:id"

export const RESTORE_STATUS_SAFRA_BY_ID = "/status-safra/:id/restore"

export const POST_STATUS_SAFRA = "/status-safra"

export const UPDATE_STATUS_SAFRA = "/status-safra/:id"

export const GET_ALL_STATUS = "/status/all"

export const GET_STATUS = "/status"

export const DELETE_STATUS_BY_ID = "/status/:id"

export const RESTORE_STATUS_BY_ID = "/status/:id/restore"

export const POST_STATUS = "/status"

export const UPDATE_STATUS = "/status/:id"

const baseUrl = "/shipping-events"

export const GET_DIGITAL_AR = baseUrl + "/digitalAr/:id"
